import './FormActionApi.css';
import TextInput from '/src/components/UI/TextField/TextInput';
import AreaList from '../UI/AreaList/AreaList';
import AreaListData from '../UI/AreaListData/AreaListData';
import ActionApiMethodType from '../../../data/constant/types/ActionApiMethodType';
import Dropdown from '../../../../../components/UI/DropDown/DropDown';
import ActionApiBodyType from '../../../data/constant/types/ActionApiBodyType';
import TitleBlock from '../TitleBlock/TitleBlock';
import ApiBlockInput from './ApiBlockInput/ApiBlockInput';
import ApiBlockInputDropdown from './ApiBlockInputDropdown/ApiBlockInputDropdown';
import { useTreeStateContext } from '../../../contexts/TreeContext';
import binarySearchString from '../../../utils/binarySearchString';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import editorAction from '../../../actions/editorAction';
import { useTreeDispatchContext } from '../../../contexts/TreeContext';
import { BlockActionApiDefault } from '../../../data/constant/blocks/BlockActionApiDefault';
import ApiBlockArea from './ApiBlockArea/ApiBlockArea';
import NiceModal from '@ebay/nice-modal-react';
import ApiModalResponseEdition from './ApiModalResponseEdition/ApiModalResponseEdition';
import CheckBox from '/src/components/UI/CheckBox/CheckBox';

function FormActionApi({ name, id }) {

    const { children, blocks } = useTreeStateContext();
    const indexBlock = binarySearchString(blocks, id, 'object_id');
    const data = blocks[indexBlock] ? blocks[indexBlock].data : BlockActionApiDefault.data
    const { api_body_type, api_method_type, headers, body, responses, url, is_proxy, url_proxy, login_proxy, password_proxy } = data

    const dispatch = useTreeDispatchContext()
    const { addVariable } = editorAction();

    const [areas, setAreas] = useState({ headers: false, body: true, responses: true, proxy: false });

    const { updateBlockData } = editorAction();

    // Helpers function to fold and unflod areas
    const setAreasUnflold = (name) => {
        if (areas[name] == undefined) {
            return;
        }

        if (name == 'headers' && areas[name] == false) {
            areas.body = false;
            areas.responses = false;
        }

        if (name != 'headers' && areas[name] == false) {
            areas.headers = false;
        }
        if (name == 'proxy' && areas[name] == false) {
            areas.body = false;
            areas.responses = false;
        }

        if (name != 'proxy' && areas[name] == false) {
            areas.proxy = false;
        }
        areas[name] = !areas[name]

        setAreas({ ...areas })
    }

    const { formState: { errors }, formState, getValues, setValue, register } = useForm({
        mode: "onBlur",
        defaultValues: {
            api_body_type, api_method_type, headers, body, responses, url, url_proxy, is_proxy, login_proxy, password_proxy
        }
    });

    // Headers, body, responses are array type data
    const setValueFormArray = (name, index, key, value) => {
        if (index == -1) {
            index = getValues(name).length - 1;
        }
        setValue(`${name}.${index}.${key}`, value);
        onSubmit(getValues());
    }

    // If the body is raw other set value
    const setValueBodyRaw = (value) => {
        setValue(`body.raw`, value);
    }

    // Set value for dropdown
    const setValueFormDropdown = (name, value) => {
        setValue(`${name}`, { name: value });
        onSubmit(getValues());
    }

    const setValueFormDropdownBody = (name, value) => {
        setValue(`${name}`, { name: value });

        if (api_body_type.name == 'raw' && value != 'raw') {
            setValue(`body`, []);
        }

        // Special case for raw data, format data
        if (api_body_type.name != 'raw' && value == 'raw') {
            setValue(`body`, { raw: '' });
        }

        onSubmit(getValues());
    }

    const deleteValue = (name, index) => {
        var data = Object.values(getValues(name))
        if (index == -1) {
            index = data.length - 1;
        }
        data = data.filter((row, idx) => idx !== index)
        // Update the tree state
        dispatch({ type: 'updateBlockData', payload: { id, data: { [name]: [...data] } } })
        setValue(name, data);
        onSubmit(getValues());
    }

    // Just somme mapping object : their objectif is to be share to the area block

    const functionApiHeaders = {
        setValue: (index, key, value) => setValueFormArray('headers', index, key, value),
        deleteValue: (index) => deleteValue('headers', index)
    }

    const functionApiBody = {
        setValue: (index, key, value) => setValueFormArray('body', index, key, value),
        deleteValue: (index) => deleteValue('body', index)
    }

    const functionApiResponses = {
        setValue: (index, key, value) => setValueFormArray('responses', index, key, value),
        deleteValue: (index) => deleteValue('responses', index)
    }

    const addNewData = async (name, scroll) => {

        const row = { key: '', value: '' }
        // Spread operator just in case, to kill the reference
        const data = [...getValues(name), row]

        // Update the tree state
        dispatch({ type: 'updateBlockData', payload: { id, data: { [name]: [...data] } } })
        setValue(name, data)

        onSubmit(getValues());
        // Scroll function is passed by the AreaList component
        scroll();
    }

    const addNewDataWithModal = async (name, scroll) => {

        const result = await NiceModal.show('editor-popup', { Component: ApiModalResponseEdition })
        var row = {};
        var variable = {};
        if (result.variable_type == "0" || result.variable_type === 0) {
            row = { key: result.key, value: result.variable.name.toUpperCase() }
        }

        if (result.variable_type == "1" || result.variable_type === 1) {
            row = { key: result.key, value: result.variable_name.toUpperCase() }
            variable = { name: result.variable_name.toLowerCase(), type: result.type }
        }

        const data = [...getValues(name), row]

        // Update the tree state
        dispatch({ type: 'updateBlockData', payload: { id, data: { [name]: [...data] } } })
        setValue(name, data)

        onSubmit(getValues());
        // Scroll function is passed by the AreaList component
        scroll();

        if (Object.keys(variable).length) {
            addVariable(variable)
        }
    }
    // Todo add the transformer in the utils/transformer
    const onSubmit = (data) => {

        const dataServer = {
            api_body: data.body,
            api_body_type: data.api_body_type.name,
            api_method_type: data.api_method_type.name,
            api_headers: data.headers,
            api_responses: data.responses,
            api_url: data.url,
            url_proxy: data.url_proxy,
            login_proxy: data.login_proxy,
            password_proxy: data.password_proxy,
            is_proxy: data.is_proxy
        }

        updateBlockData(id, data, dataServer)
    }

    const [valueUrl, setValueUrl] = useState(url)
    const setValueInputUrl = (e) => {
        setValue('url', e.target.value)
        setValueUrl(e.target.value)
    }

    const [valueUrlProxy, setValueUrlProxy] = useState(url_proxy)
    const [valueLoginProxy, setLoginProxy] = useState(login_proxy)
    const [valuePasswordProxy, setPasswordProxy] = useState(password_proxy)
    const [valueIsProxy, setIsProxy] = useState(is_proxy)

    const setValueInputUrlProxy = (e) => {
        setValue('url_proxy', e.target.value)
        setValueUrlProxy(e.target.value)
    }

    const setValueInputLoginProxy = (e) => {
        setValue('login_proxy', e.target.value)
        setLoginProxy(e.target.value)
    }
    const setValueInputPasswordProxy = (e) => {
        setValue('password_proxy', e.target.value)
        setPasswordProxy(e.target.value)
    }
    const setValueInputIsProxy = (e) => {
        let b = !getValues("is_proxy");
        setValue('is_proxy', b)
        setIsProxy(b)
        onBlurInputUrl()
    }

    if (body.raw) {
        body.raw = body.raw.replace(/\\n/g, '\n')
    }

    const onBlurInputUrl = () => onSubmit(getValues())

    return (
        <>
            <TitleBlock title="Api" titleInput="Api name" name={name} id={id} />
            <div className='area-edit'>
                <div className='grid-row-input'>
                    <label className="dropdown_title" style={{ marginTop: '10px' }}>Url : </label>
                    <div className='dropdown_container'>
                        <TextInput {...register('url')} className="editor-input title_input" value={valueUrl} onChange={setValueInputUrl} onBlur={onBlurInputUrl} />
                    </div>
                </div>
                <div className='grid-row'>
                    <label className="dropdown_title">Method : </label>
                    <div className='dropdown_container'>
                        <Dropdown name="api_method_type" choices={ActionApiMethodType} defaultChoice={api_method_type.name} width="260px" setValue={setValueFormDropdown} />
                    </div>
                </div>
                <div className='grid-row'>
                    <label className="dropdown_title">Body Type : </label>
                    <div className='dropdown_container'>
                        <Dropdown name="api_body_type" choices={ActionApiBodyType} defaultChoice={api_body_type.name} width="260px" setValue={setValueFormDropdownBody} />
                    </div>
                </div>
                <div className='container_is_proxy'>
                    <label className="dropdown_title" style={{ marginTop: '10px' }}>With Proxy : </label>
                    <CheckBox name="Resume" onChange={setValueInputIsProxy} checked={getValues("is_proxy")} />
                </div>
                {
                    is_proxy ?
                    <AreaList title="Proxy" maxHeight="140px" unfold={areas.proxy} setUnfold={() => setAreasUnflold('proxy')} onClickButton={(arg) => addNewData('proxy', ...arg)}>
                        <div className='grid_proxy'>
                            <label className="dropdown_title" style={{ marginTop: '10px' }}>Url </label>
                            <div className='dropdown_container'>
                                <TextInput {...register('url_proxy')} className="editor-input title_input proxy_input" value={valueUrlProxy} onChange={setValueInputUrlProxy} onBlur={onBlurInputUrl} />
                            </div>
                        </div>
                        <div className='grid_proxy'>
                            <label className="dropdown_title" style={{ marginTop: '10px' }}>Login </label>
                            <div className='dropdown_container'>
                                <TextInput {...register('proxy_login')} className="editor-input title_input proxy_input" value={valueLoginProxy} onChange={setValueInputLoginProxy} onBlur={onBlurInputUrl} />
                            </div>
                        </div>
                        <div className='grid_proxy'>
                            <label className="dropdown_title" style={{ marginTop: '10px' }}>Password </label>
                            <div className='dropdown_container'>
                                <TextInput {...register('proxy_password')} className="editor-input title_input proxy_input" value={valuePasswordProxy} onChange={setValueInputPasswordProxy} onBlur={onBlurInputUrl} />
                            </div>
                        </div>
                    </AreaList>
                 : ""}

                <AreaList title="Headers" maxHeight="140px" buttonLabel="Add a Header" unfold={areas.headers} setUnfold={() => setAreasUnflold('headers')} onClickButton={(arg) => addNewData('headers', ...arg)}>
                    <AreaListData data={headers} ComponentRow={ApiBlockInput} FunctionsRow={functionApiHeaders}></AreaListData>
                </AreaList>
                <AreaList title="Body" maxHeight="260px" {...(api_body_type.name != 'raw' ? { buttonLabel: "Add a Param" } : {})} unfold={areas.body} setUnfold={() => setAreasUnflold('body')} onClickButton={(arg) => addNewData('body', ...arg)}>
                    {api_body_type.name != 'raw' && <AreaListData data={body} ComponentRow={ApiBlockInput} FunctionsRow={functionApiBody}></AreaListData>}
                    {api_body_type.name == 'raw' && <ApiBlockArea value={body.raw} setValue={setValueBodyRaw} onBlur={() => onSubmit(getValues())} />}
                </AreaList>
                <AreaList title="Responses" maxHeight="140px" buttonLabel="Add a Response" unfold={areas.responses} setUnfold={() => setAreasUnflold('responses')} onClickButton={(arg) => addNewDataWithModal('responses', ...arg)}>
                    <AreaListData data={responses} ComponentRow={ApiBlockInputDropdown} FunctionsRow={functionApiResponses}></AreaListData>
                </AreaList>
                { /* espacement de fin, juste pour du visuel */}
                <div style={{paddingBottom : "35px"}}/> 
            </div>
        </>
    )
}

export default FormActionApi;